export default __webpack_public_path__ + "static/media/honda.55316742.svg";